// src/lib/eventTypes.js
// Deterministic, brand-aligned styling per event type (replaces random colors).
export const EVENT_TYPE_STYLES = {
    event:       { label: 'Event',       dot: 'bg-purple-500', chip: 'bg-purple-100 text-purple-700 ring-purple-200', solid: 'bg-purple-600' },
    fundraiser:  { label: 'Fundraiser',  dot: 'bg-gold-500',   chip: 'bg-gold-100 text-gold-800 ring-gold-200',       solid: 'bg-gold-500' },
    celebration: { label: 'Celebration', dot: 'bg-pink-500',   chip: 'bg-pink-100 text-pink-700 ring-pink-200',        solid: 'bg-pink-500' },
    meeting:     { label: 'Meeting',     dot: 'bg-blue-500',   chip: 'bg-blue-100 text-blue-700 ring-blue-200',        solid: 'bg-blue-600' },
    deadline:    { label: 'Deadline',    dot: 'bg-red-500',    chip: 'bg-red-100 text-red-700 ring-red-200',           solid: 'bg-red-600' },
    general:     { label: 'General',     dot: 'bg-slate-400',  chip: 'bg-slate-100 text-slate-700 ring-slate-200',     solid: 'bg-slate-500' },
};

export const getEventStyle = (type) =>
    EVENT_TYPE_STYLES[(type || 'general').toLowerCase()] || EVENT_TYPE_STYLES.general;
